import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import MuiButtonBase from '@material-ui/core/ButtonBase';

import DocumentsSignDialog from 'components/common/DocumentsSignDialog';

const styles = () => ({
  root: {
    display: 'block',
    height: 48,
    width: '100%',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'top center',
  },
});

class TemplatePreviewFillFormFieldSignature extends Component {
  constructor(props) {
    super(props);

    this.state = {
      signDialogOpen: false,
    };

    this.onButtonClick = this.onButtonClick.bind(this);
    this.onSignDialogClose = this.onSignDialogClose.bind(this);
  }

  onButtonClick() {
    this.setState({ signDialogOpen: true });
  }

  onSignDialogClose() {
    this.setState({ signDialogOpen: false });
  }

  render() {
    const {
      input, classes,
    } = this.props;
    const { signDialogOpen } = this.state;
    return (
      <Fragment>
        <MuiButtonBase
          onClick={this.onButtonClick}
          className={classes.root}
          style={{
            ...input.value && input.value.length > 0 ? {
              backgroundImage: `url(${input.value})`,
            } : {},
          }}
        />
        <DocumentsSignDialog
          open={signDialogOpen}
          initialValues={{
            signature: input.value,
          }}
          onClose={this.onSignDialogClose}
          onSubmitSuccess={(values) => {
            input.onChange(values.signature);
            this.onSignDialogClose();
          }}
        />
      </Fragment>
    );
  }
}

TemplatePreviewFillFormFieldSignature.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
    ]).isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(TemplatePreviewFillFormFieldSignature);



// WEBPACK FOOTER //
// ./src/components/settings/TemplatePreviewFillForm/TemplatePreviewFillFormFieldSignature.js